"use client";

import dynamic from "next/dynamic";
import { useAuthContext } from "@/components/AuthContext/AuthContext";
const LoginForm = dynamic(() => import("@/components/auth/LoginForm"), {
  ssr: false
});
const OTPForm = dynamic(() => import("@/components/auth/OTPForm"), {
  ssr: false
});
const ForgotPasswordForm = dynamic(() => import("@/components/auth/ForgotPassowrdForm"), {
  ssr: false
});
const LoginFlow = () => {
  const {
    activeForm
  } = useAuthContext();
  return <>
      {activeForm === "LOGIN" && <LoginForm />}
      {activeForm === "OTP" && <OTPForm />}
      {(activeForm === "FORGOT" || activeForm === "FORGOT_SUCCESS") && <ForgotPasswordForm />}
    </>;
};
export default LoginFlow;